export default __webpack_public_path__ + "static/spanish-forms-9682c2f2f6fe0cccc59cd8ef0cfdfc15.pdf";